import React from 'react';
import shimbun8 from '../assets/shimbun8.png';
import shimbun9 from '../assets/shimbun9.png';
import shimbun10 from '../assets/shimbun10.png';
import shimbun11 from '../assets/shimbun11.png';
import './CSS/Interview.css';

function Interview4() {
  return (
    <main className="interview-page">
      <div className="interview-masthead">
        BUDO JAPAN Exclusive &nbsp;·&nbsp; Special Feature &nbsp;·&nbsp; Martial Arts Heritage
      </div>

      {/* HERO */}
      <section className="interview-hero">
        <img
          className="interview-hero-img"
          src={shimbun8}
          alt="Motohiro Fukakusa Shihan Interview"
        />

        <div className="interview-hero-overlay"></div>

        <div className="interview-hero-content">
          <div className="interview-hero-label">
            Special Feature · BUDO JAPAN (2020)
          </div>

          <h1 className="interview-hero-title">
            The Father of Aikido in Thailand
            <br />
            <em>The Man Who Brought the Art of Peace to the Land of Muay Thai</em>
          </h1>

          <p className="interview-hero-subtitle">
            The remarkable story of Motohiro Fukakusa, who was tasked with propagating Aikido in Thailand with only three years of training experience.
          </p>

          <div className="interview-hero-byline">
            <div className="interview-hero-avatar">
              <img src={shimbun8} alt="Grigoris Miliaresis" />
            </div>

            <div className="interview-hero-byline-text">
              <strong>Grigoris Miliaresis</strong>
              Author · Budo Japan
            </div>
          </div>
        </div>
      </section>

      <div className="interview-article-wrap">
        <div className="interview-intro-block">
          <p>
            Even though the author had practiced Aikido for nearly a decade and lived in Japan, he had never heard the name Motohiro Fukakusa until receiving this assignment. However, upon visiting the National Olympic Memorial Youth Center in Yoyogi, he immediately realized that this was a master of immense significance in the martial arts world.
          </p>
        </div>

        {/* SECTION 1 */}
        <div className="interview-section-header">
          <div className="interview-section-num">01</div>
          <div className="interview-section-title-wrap">
            <span>The Beginning · The Mission</span>
            <h2>An Impossible Assignment</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float">
            <img
              src={shimbun9}
              alt="Motohiro Fukakusa"
            />
            <figcaption>
              Motohiro Fukakusa was tasked with introducing Aikido to Thailand with just three years of training experience.
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                How did Master Fukakusa's journey in Thailand begin?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                He started practicing Aikido in the early 1960s, a period when Aikido Hombu Dojo was still under the direct leadership of Morihei Ueshiba (O-Sensei), the founder of the art. During that era, he was entrusted with a formidable mission: to introduce and propagate Aikido in Thailand.
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                Why was this mission considered so challenging?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                Because Thailand was the homeland of Muay Thai—a martial art deeply woven into the local culture and fighting consciousness. Remarkably, he embarked on this mission with only three years of training and a 2nd Dan black belt awarded directly by O-Sensei.
              </div>
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "And he succeeded! Against all odds, he established Aikido not only in Thailand, but across the vast expanse of South-East Asia."
          </p>
          <cite>— Grigoris Miliaresis</cite>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">Renbukan · โดโจเรนบูกัง</span>
          <h3>Foundational Ground</h3>
          <p>
            Through unwavering perseverance, Fukakusa transitioned his practitioners from the College of Physical Education at the National Stadium to establish their own dedicated sanctuary: Renbukan Dojo.
          </p>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">ASEANF · เครือข่ายอาเซียน</span>
          <h3>Regional Network</h3>
          <p>
            In 2008, he founded the Aikido of South-East Asian Nations Fellowship (ASEANF) to create a united foundation for the discipline, spanning Thailand, Cambodia, Laos, Malaysia, Myanmar, the Philippines, Singapore, and Vietnam.
          </p>
        </div>

        {/* SECTION 2 */}
        <div className="interview-section-header">
          <div className="interview-section-num">02</div>
          <div className="interview-section-title-wrap">
            <span>International Congress · Tokyo 2012</span>
            <h2>The Class of "Khun Somchai"</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float" style={{ float: 'right', marginLeft: '24px', marginRight: '0' }}>
            <img src={shimbun10} alt="Class of Khun Somchai" />
            <figcaption>
              Teaching with effortless command, "Khun Somchai" captivated over 400 practitioners on the tatami mats.
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                You had the opportunity to observe his seminar in person, correct?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                Yes. During the 11th International Aikido Congress in Tokyo (2012), I attended the seminar led by Fukakusa—known affectionately in Thailand as "Khun Somchai"—held at the National Olympic Memorial Youth Center in Yoyogi.
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                What was the atmosphere on the mat during his session?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                As soon as the standard warm-up finished and instruction began, any doubts I had completely evaporated. He commanded the undivided attention of more than 400 practitioners on the tatami. He demonstrated that true relaxation is never limp passivity, but rather possessing sufficient neural energy to control the opponent while remaining supple enough to adapt fluidly to their reactions.
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3 */}
        <div className="interview-section-header">
          <div className="interview-section-num">03</div>
          <div className="interview-section-title-wrap">
            <span>Local Influence · Martial Realism</span>
            <h2>Openings and Martial Awareness</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float">
            <img src={shimbun11} alt="Martial Awareness and Atemi" />
            <figcaption>
              Delivering rapid Atemi strikes to highlight critical openings in a partner's technique.
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                How did living and teaching in a country renowned for Muay Thai influence his methodology?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                I noticed that Master Fukakusa's sharp edge and acute sense of vulnerability were honed by proving Aikido before people accustomed to one of the world's most relentless and practical striking arts—Muay Thai.
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>Q</span>
              </div>
              <div className="interview-exchange-text">
                How did he demonstrate this principle during practice?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>Author</span>
              </div>
              <div className="interview-exchange-text">
                Every time he selected a training partner, he exposed their openings with lightning-fast Atemi (strikes). This served as an essential reminder of what is often overlooked in modern Aikido: the awareness that this is a martial art, and your training partner must be regarded as an opponent ready to exploit any lapse in focus.
              </div>
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "A technique that begins or proceeds with an opening is a technique lacking awareness—and its outcome will inevitably be weak and compromised."
          </p>
          <cite>— Core Principle Emphasized by Motohiro Fukakusa</cite>
        </div>

        <div className="interview-ornament">— · · · —</div>

        <div className="interview-closing-box">
          <h3>Conclusion: Fifty Years of Devotion</h3>
          <p>
            Motohiro Fukakusa proved that what initially seemed an impossible assignment for a young man with only three years of training could blossom into the bedrock of Aikido across South-East Asia. Holding the rank of 8th Dan, it stands as a well-earned testament to over half a century of dedicated practice.
          </p>
          <p className="interview-closing-note">
            "This is the profound legacy that the Father of Aikido in Thailand has gifted to the global martial arts community."
          </p>
        </div>
      </div>

      <footer className="interview-footer">
        <strong>Sources & References</strong>
        <br />
        Adapted from the article "International Aikido Federation's 11th International Aikido Congress (Tokyo, 2012): Fukakusa Motohiro's Class" by Grigoris Miliaresis, published in Budo Japan (2020).
      </footer>
    </main>
  );
}

export default Interview4;
